import { Component } from '@angular/core';
import { CmsConfig } from '../../config/cms.config';

@Component({
  selector: 'kion-cms-contact-confirmation',
  templateUrl: './contact-confirmation.component.html',
  styleUrls: ['./contact-confirmation.component.scss']
})
export class ContactConfirmationComponent {

  backLink: string;

  constructor(private cmsConfig: CmsConfig) {
    this.backLink = '/' + this.cmsConfig.routes?.faqBaseRoute;
  }
}
